/**
 *
 * This file was generated with Adobe XD React Exporter
 * Exporter for Adobe XD is written by: Johannes Pichler <j.pichler@webpixels.at>
 *
 **/

import React from "react";

const StageImages = ({ type = "default" }) =>
  type === "default" ? (
    <svg
      width={450.172}
      height={246.977}
      viewBox="0 0 450.172 246.977"
      style={{ maxWidth: "100%", transform: "translateZ(0)" }}
    >
      <defs>
        <style>
          {
            ".stage-images-a{fill:#e6f8fb;}.stage-images-a,.stage-images-c,.stage-images-f,.stage-images-j,.stage-images-x{fill-rule:evenodd;}.stage-images-ad,.stage-images-b,.stage-images-c,.stage-images-f,.stage-images-j,.stage-images-l,.stage-images-x{fill:none;}.stage-images-b{stroke:#4f4a45;stroke-width:1.702px;}.stage-images-b,.stage-images-c,.stage-images-d,.stage-images-e,.stage-images-f,.stage-images-j,.stage-images-l,.stage-images-o,.stage-images-r,.stage-images-s,.stage-images-y,.stage-images-z{strokeLinecap:round;}.stage-images-b,.stage-images-c,.stage-images-d,.stage-images-e,.stage-images-f,.stage-images-j,.stage-images-k,.stage-images-l,.stage-images-o,.stage-images-r,.stage-images-s,.stage-images-v,.stage-images-x,.stage-images-y,.stage-images-z{stroke-linejoin:round;}.stage-images-c,.stage-images-f{stroke:gray;strokeWidth:1.5px;}.stage-images-c{stroke-dasharray:4;}.stage-images-d,.stage-images-p{fill:#fff;}.stage-images-d,.stage-images-e,.stage-images-j,.stage-images-k,.stage-images-l,.stage-images-o,.stage-images-r,.stage-images-s,.stage-images-v,.stage-images-x,.stage-images-y,.stage-images-z{stroke:#45413c;}.stage-images-ab,.stage-images-e{fill:#e5e5e5;}.stage-images-g,.stage-images-r{fill:#45413c;}.stage-images-g{opacity:0.15;}.stage-images-h{fill:#0dbedc;}.stage-images-i{fill:#1ad2f1;}.stage-images-j,.stage-images-k,.stage-images-l,.stage-images-o,.stage-images-r,.stage-images-s,.stage-images-v,.stage-images-x,.stage-images-y,.stage-images-z{stroke-width:1.772px;}.stage-images-k{fill:#0cb0cc;}.stage-images-m,.stage-images-o{fill:#ffcebf;}.stage-images-n{fill:#ffb59e;}.stage-images-q,.stage-images-y{fill:#e8f4fa;}.stage-images-s,.stage-images-t{fill:#a86c4d;}.stage-images-u{fill:#de926a;}.stage-images-v,.stage-images-z{fill:#bdbec0;}.stage-images-w{fill:#f0f0f0;}.stage-images-aa{fill:#0059c0;}.stage-images-ac{font-size:16px;font-family:MyriadPro-Semibold, Myriad Pro;font-weight:600;}.stage-images-ae{fill:#ffdc0f;}.stage-images-af{fill:#12cc8a;}"
          }
        </style>
      </defs>
      <g transform="translate(-999.763 -286.578)">
        <g transform="translate(999.478 320.033)">
          <g transform="translate(1.136 8.015)">
            <path
              className="stage-images-a"
              d="M111.662,0a104.848,104.848,0,0,1,95.3,148.465H16.366A104.848,104.848,0,0,1,111.662,0Z"
              transform="translate(3.127)"
            />
            <line
              className="stage-images-b"
              x2={206.42}
              transform="translate(11.909 149.021)"
            />
            <line
              className="stage-images-b"
              x2={6.616}
              transform="translate(0 149.021)"
            />
            <line
              className="stage-images-b"
              x2={6.616}
              transform="translate(222.167 149.021)"
            />
          </g>
          <path
            className="stage-images-c"
            d="M5.478-7.064c1.28,4.5,9.306,34.363,4.243,43.433-4.1,7.353-16.388,22.543-17.087,38.7-.707,16.337,12.569,32.8,24.981,48.9"
            transform="translate(253.932 69.388) rotate(47)"
          />
          <g transform="translate(253.548 53.838) rotate(5)">
            <g transform="translate(0 0)">
              <path
                className="stage-images-d"
                d="M.335,2.166A1.288,1.288,0,0,1,.136.723,1.315,1.315,0,0,1,1.417,0L44.6,3.4a1.309,1.309,0,0,1,1.161.952,1.292,1.292,0,0,1-.509,1.4L9.841,30.439a1.324,1.324,0,0,1-1.472.027A1.292,1.292,0,0,1,7.8,29.123l2.953-14.688a1.287,1.287,0,0,0-.309-1.12Z"
              />
              <path
                className="stage-images-e"
                d="M2.978,10.089.025,24.777A1.293,1.293,0,0,0,.6,26.119a1.325,1.325,0,0,0,1.471-.026L37.479,1.406A1.293,1.293,0,0,0,37.989,0L2.956,9.493A1.276,1.276,0,0,1,2.978,10.089Z"
                transform="translate(7.773 4.347)"
              />
            </g>
          </g>
          <path
            className="stage-images-c"
            d="M-.66-50.057c-34.281,48.975,13.6,85.091,25.446,95.549C42.56,61.177,15.468,92.867,35,104.54q14.466,8.645,37.356,44.371"
            transform="translate(242.157 26.516) rotate(60)"
          />
          <g transform="translate(274.733 -12.528) rotate(-2)">
            <g transform="translate(0 0)">
              <path
                className="stage-images-d"
                d="M.335,2.166A1.288,1.288,0,0,1,.136.723,1.315,1.315,0,0,1,1.417,0L44.6,3.4a1.309,1.309,0,0,1,1.161.952,1.292,1.292,0,0,1-.509,1.4L9.841,30.439a1.324,1.324,0,0,1-1.472.027A1.292,1.292,0,0,1,7.8,29.123l2.953-14.688a1.287,1.287,0,0,0-.309-1.12Z"
              />
              <path
                className="stage-images-e"
                d="M2.978,10.089.025,24.777A1.293,1.293,0,0,0,.6,26.119a1.325,1.325,0,0,0,1.471-.026L37.479,1.406A1.293,1.293,0,0,0,37.989,0L2.956,9.493A1.276,1.276,0,0,1,2.978,10.089Z"
                transform="translate(7.773 4.347)"
              />
            </g>
          </g>
          <g transform="translate(319.315 72.105) rotate(60)">
            <g transform="translate(0 0)">
              <g transform="translate(41.192 197.085) rotate(178)">
                <path
                  className="stage-images-c"
                  d="M.034,126.443Q-.924,35.11,25.47,54.454c2.057,1.608,3.561,5,4.025,9.069a23.47,23.47,0,0,1-1.361,11.444c-2.947,6.75-7.954,8.967-12.21,5.4C-1.516,66.42,10.565,9.514,31.653,0"
                  transform="translate(0 1.897)"
                />
                <path
                  className="stage-images-f"
                  d="M0,.2A13.529,13.529,0,0,1,1.456,0"
                  transform="translate(35.28 0)"
                />
              </g>
              <g transform="matrix(0.545, -0.839, 0.839, 0.545, 9.34, 70.016)">
                <path
                  className="stage-images-d"
                  d="M.538,3.51A2.1,2.1,0,0,1,2.272.007l69.236,5.5a2.1,2.1,0,0,1,1.046,3.817L15.779,49.33A2.1,2.1,0,0,1,12.5,47.2l4.734-23.8a2.1,2.1,0,0,0-.5-1.815Z"
                  transform="translate(0 0)"
                />
                <path
                  className="stage-images-e"
                  d="M4.774,16.351.04,40.155a2.1,2.1,0,0,0,3.276,2.132L60.093,2.278A2.107,2.107,0,0,0,60.91,0L4.74,15.385A2.09,2.09,0,0,1,4.774,16.351Z"
                  transform="translate(12.463 7.044)"
                />
              </g>
            </g>
          </g>
          <g transform="translate(34.249 12.043)">
            <g transform="translate(0 0)">
              <path
                className="stage-images-g"
                d="M37,117.4c0,2.138-7.97,3.869-19.15,3.869S.886,119.555.886,117.4s5.78-3.869,16.962-3.869S37,115.268,37,117.4Z"
                transform="translate(-0.886 50.601)"
              />
              <g transform="translate(6.128)">
                <path
                  className="stage-images-h"
                  d="M72.773,58.658a44.08,44.08,0,0,0-44.08,44.075V117.4a3.678,3.678,0,0,1-5.53,3.005l-5.675-3.413a8.557,8.557,0,0,0-8.819,14.667c5.788,3.474,9.5,6.353,16.3,6.353a20.738,20.738,0,0,0,19.366-13.952h72.518V102.733a44.08,44.08,0,0,0-44.08-44.075Z"
                  transform="translate(1.159 25.603)"
                />
                <path
                  className="stage-images-i"
                  d="M65.208,58.658a44.08,44.08,0,0,0-44.08,44.075v11.383a44.08,44.08,0,0,1,88.159,0V102.74a44.08,44.08,0,0,0-44.08-44.082Z"
                  transform="translate(8.724 25.603)"
                />
                <path
                  className="stage-images-j"
                  d="M72.773,58.658a44.08,44.08,0,0,0-44.08,44.075V117.4a3.678,3.678,0,0,1-5.53,3.005l-5.675-3.413a8.557,8.557,0,0,0-8.819,14.667c5.788,3.474,9.5,6.353,16.3,6.353a20.738,20.738,0,0,0,19.366-13.952h72.518V102.733a44.08,44.08,0,0,0-44.08-44.075Z"
                  transform="translate(1.159 25.603)"
                />
                <path
                  className="stage-images-k"
                  d="M59.917,54.747H52.809a12.087,12.087,0,1,0,0,24.172h7.109a12.087,12.087,0,1,0,0-24.172Z"
                  transform="translate(17.569 23.821)"
                />
                <line
                  className="stage-images-l"
                  y1={25.596}
                  transform="translate(45.494 124.07)"
                />
                <line
                  className="stage-images-l"
                  y1={25.596}
                  transform="translate(102.37 124.07)"
                />
                <path
                  className="stage-images-m"
                  d="M44.574,51.816v15.91s-.111,6.758,9.954,6.841c10.06-.083,9.954-6.841,9.954-6.841V51.816Z"
                  transform="translate(19.404 22.486)"
                />
                <path
                  className="stage-images-n"
                  d="M44.574,60.635c0,.4.2,6.743,9.954,6.823,9.75-.08,9.951-6.425,9.954-6.823V51.816H44.574Z"
                  transform="translate(19.404 22.486)"
                />
                <path
                  className="stage-images-j"
                  d="M44.574,51.816v15.91s-.111,6.758,9.954,6.841c10.06-.083,9.954-6.841,9.954-6.841V51.816Z"
                  transform="translate(19.404 22.486)"
                />
                <path
                  className="stage-images-o"
                  d="M14.354,97.731H10.691a8.215,8.215,0,0,0-8.123,8.3v7.914A3.423,3.423,0,0,0,5.06,117.2a26.991,26.991,0,0,0,14.922,0,3.415,3.415,0,0,0,2.492-3.253v-7.914A8.213,8.213,0,0,0,14.354,97.731Z"
                  transform="translate(0.269 43.402)"
                />
                <path
                  className="stage-images-p"
                  d="M23.842,121.1H3.464a2.837,2.837,0,0,1-2.812-3.276l.72-4.669A12.43,12.43,0,0,1,13.65,102.608h0A12.433,12.433,0,0,1,25.936,113.15l.717,4.669a2.837,2.837,0,0,1-2.812,3.286Z"
                  transform="translate(-0.619 45.623)"
                />
                <path
                  className="stage-images-q"
                  d="M13.469,106.522A12.43,12.43,0,0,0,1.184,117.075l-.168,1.081a2.793,2.793,0,0,0,2.26,1.176H23.653a2.793,2.793,0,0,0,2.26-1.176l-.165-1.081A12.433,12.433,0,0,0,13.469,106.522Z"
                  transform="translate(-0.438 47.407)"
                />
                <path
                  className="stage-images-j"
                  d="M23.842,121.1H3.464a2.837,2.837,0,0,1-2.812-3.276l.72-4.669A12.43,12.43,0,0,1,13.65,102.608h0A12.433,12.433,0,0,1,25.936,113.15l.717,4.669a2.837,2.837,0,0,1-2.812,3.286Z"
                  transform="translate(-0.619 45.623)"
                />
                <circle
                  className="stage-images-r"
                  cx={1.456}
                  cy={1.456}
                  r={1.456}
                  transform="translate(11.334 153.691)"
                />
                <g transform="translate(38.358)">
                  <g transform="translate(1.448 8.896)">
                    <path
                      className="stage-images-o"
                      d="M63.11,36.177V29.068a28.438,28.438,0,0,0-56.876,0v7.109a5.688,5.688,0,0,0,0,11.375c.119,0,.232-.028.348-.034a28.4,28.4,0,0,0,56.18,0c.119,0,.23.034.348.034a5.688,5.688,0,1,0,0-11.375Z"
                      transform="translate(-0.546 -0.63)"
                    />
                    <circle
                      className="stage-images-n"
                      cx={3.554}
                      cy={3.554}
                      r={3.554}
                      transform="translate(14.22 42.679)"
                    />
                    <circle
                      className="stage-images-n"
                      cx={3.554}
                      cy={3.554}
                      r={3.554}
                      transform="translate(46.925 42.679)"
                    />
                    <path
                      className="stage-images-j"
                      d="M21.785,26.932a4.643,4.643,0,0,0-8.556,0"
                      transform="translate(5.232 10.059)"
                    />
                    <path
                      className="stage-images-j"
                      d="M37.431,26.917a4.643,4.643,0,0,0-8.556,0"
                      transform="translate(12.359 10.052)"
                    />
                  </g>
                  <path
                    className="stage-images-s"
                    d="M55.452,40.662c-2.922,6.817-3.07,8.548-4.965,9.028l-2.156.539a2.559,2.559,0,0,1-3.049-1.674c-1.883-4.364-5.115-7.97-9.668-7.97h-3.97c-4.553,0-7.787,3.611-9.668,7.97a2.559,2.559,0,0,1-3.049,1.674l-2.167-.544c-1.9-.475-2.045-2.205-4.968-9.028-.952-2.221-3.745-1.519-6.268-1.548a28.092,28.092,0,1,0,56.18,0C59.193,39.143,56.4,38.454,55.452,40.662Z"
                    transform="translate(1.948 16.66)"
                  />
                  <path
                    className="stage-images-t"
                    d="M6.576,45.736A2.907,2.907,0,0,1,3.287,44.33a34.09,34.09,0,0,1-2.871-15.1A28.234,28.234,0,0,1,28.643,1c7.7,0,23.1-1.857,28.232,4.986,22.513,5,14.672,43.5,12.381,41.206a5.417,5.417,0,0,0-3.82-1.7,5.989,5.989,0,0,0-3.869,1.145,43.221,43.221,0,0,1-7.222-27.654c0,7.7-16.867,14.37-31.105,14.37A32.9,32.9,0,0,1,13,31.9a39.96,39.96,0,0,1-1.207,14.736A6.42,6.42,0,0,0,6.576,45.736Z"
                    transform="translate(-0.39 -0.767)"
                  />
                  <path
                    className="stage-images-u"
                    d="M28.635,8.874c7.7,0,23.1-1.86,28.234,4.983C67.754,16.277,71.543,26.53,72.291,36.216c.823-11.148-1.465-27.128-15.422-30.231C51.739-.866,36.339,1,28.635,1A28.234,28.234,0,0,0,.408,29.234c0,1.522.054,3.07.188,4.607A28.234,28.234,0,0,1,28.635,8.874Z"
                    transform="translate(-0.382 -0.768)"
                  />
                  <path
                    className="stage-images-j"
                    d="M20.942,44.983a11.987,11.987,0,0,0,11.349-.013"
                    transform="translate(8.972 19.368)"
                  />
                  <path
                    className="stage-images-j"
                    d="M6.576,45.736A2.907,2.907,0,0,1,3.287,44.33a34.09,34.09,0,0,1-2.871-15.1A28.234,28.234,0,0,1,28.643,1c7.7,0,23.1-1.857,28.232,4.986,22.513,5,14.672,43.5,12.381,41.206a5.417,5.417,0,0,0-3.82-1.7,5.989,5.989,0,0,0-3.869,1.145,43.221,43.221,0,0,1-7.222-27.654c0,7.7-16.867,14.37-31.105,14.37A32.9,32.9,0,0,1,13,31.9a39.96,39.96,0,0,1-1.207,14.736A6.42,6.42,0,0,0,6.576,45.736Z"
                    transform="translate(-0.39 -0.767)"
                  />
                </g>
              </g>
              <g transform="translate(23.96 123.298)">
                <g transform="translate(30.055 0)">
                  <path
                    className="stage-images-g"
                    d="M109.421,44.935c0,2.726-23.989,4.937-57.611,4.937S.782,47.662.782,44.935,18.175,40,51.81,40,109.421,42.206,109.421,44.935Z"
                    transform="translate(-0.782 17.616)"
                  />
                  <path
                    className="stage-images-v"
                    d="M95.631,43.7h-85.2a5.159,5.159,0,0,1-5.159-5.159v-3.07H100.79v3.07A5.159,5.159,0,0,1,95.631,43.7Z"
                    transform="translate(1.265 15.555)"
                  />
                  <path
                    className="stage-images-w"
                    d="M102.319,51.443H6.8L1.964,7.792A6.588,6.588,0,0,1,8.5.415h92.173a6.588,6.588,0,0,1,6.536,7.377Z"
                    transform="translate(-0.264 -0.415)"
                  />
                  <path
                    className="stage-images-p"
                    d="M2.67,14.194a5.987,5.987,0,0,1,.9-1.684A6.58,6.58,0,0,1,8.5,10.291h92.178A6.58,6.58,0,0,1,105.6,12.51a6.011,6.011,0,0,1,.892,1.674l.717-6.392A6.588,6.588,0,0,0,100.675.415H8.5A6.588,6.588,0,0,0,1.961,7.792Z"
                    transform="translate(-0.266 -0.415)"
                  />
                  <path
                    className="stage-images-x"
                    d="M102.319,51.443H6.8L1.964,7.792A6.588,6.588,0,0,1,8.5.415h92.173a6.588,6.588,0,0,1,6.536,7.377Z"
                    transform="translate(-0.264 -0.415)"
                  />
                </g>
                <g transform="translate(0 53.399)">
                  <path
                    className="stage-images-y"
                    d="M24.353,19.015H3.46A2.987,2.987,0,0,1,.476,16.028V13.033H27.338V16.02a2.987,2.987,0,0,1-2.984,2.995Z"
                    transform="translate(-0.46 4.881)"
                  />
                  <path
                    className="stage-images-h"
                    d="M27.341,18.639H.468L5.759,2.766A2.984,2.984,0,0,1,8.6.725H19.223a2.984,2.984,0,0,1,2.837,2.04Z"
                    transform="translate(-0.463 -0.725)"
                  />
                  <path
                    className="stage-images-i"
                    d="M19.22.725H8.593a2.984,2.984,0,0,0-2.837,2.04L.465,18.639H2.3L21.982,2.6A2.984,2.984,0,0,0,19.22.725Z"
                    transform="translate(-0.465 -0.725)"
                  />
                  <path
                    className="stage-images-j"
                    d="M27.341,18.639H.468L5.759,2.766A2.984,2.984,0,0,1,8.6.725H19.223a2.984,2.984,0,0,1,2.837,2.04Z"
                    transform="translate(-0.463 -0.725)"
                  />
                  <line
                    className="stage-images-l"
                    x2={2.987}
                    transform="translate(11.948 4.112)"
                  />
                  <rect
                    className="stage-images-z"
                    width={5.971}
                    height={5.971}
                    transform="translate(14.935 17.914)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <g transform="translate(-15 41)">
          <path
            className="stage-images-p"
            d="M10.8,0H86.458a10.8,10.8,0,0,1,10.8,10.8V47.181a10.8,10.8,0,0,1-10.8,10.8H10.8A10.8,10.8,0,0,1,0,47.181V10.8A10.8,10.8,0,0,1,10.8,0Z"
            transform="translate(1363.594 393.473)"
          />
          <g transform="translate(1374.853 403.264)">
            <path
              className="stage-images-aa"
              d="M5.379,0,4.109,4.108,0,4.11,3.325,6.65,2.056,10.76,5.379,8.22,8.7,10.76,7.435,6.65,10.76,4.11l-4.109,0Z"
              transform="translate(0.524 0)"
            />
            <path
              className="stage-images-aa"
              d="M5.379,0,4.109,4.108,0,4.11,3.325,6.65,2.056,10.76,5.379,8.22,8.7,10.76,7.435,6.65,10.76,4.11l-4.109,0Z"
              transform="translate(0.524)"
            />
            <path
              className="stage-images-aa"
              d="M5.379,0,4.109,4.108,0,4.11,3.325,6.65,2.056,10.76,5.379,8.22,8.7,10.76,7.435,6.65,10.76,4.11l-4.109,0Z"
              transform="translate(16.664 0)"
            />
            <path
              className="stage-images-aa"
              d="M5.379,0,4.109,4.108,0,4.11,3.325,6.65,2.056,10.76,5.379,8.22,8.7,10.76,7.435,6.65,10.76,4.11l-4.109,0Z"
              transform="translate(32.803 0)"
            />
            <path
              className="stage-images-aa"
              d="M5.379,0,4.109,4.108,0,4.11,3.325,6.65,2.056,10.76,5.379,8.22,8.7,10.76,7.435,6.65,10.76,4.11l-4.109,0Z"
              transform="translate(48.943 0)"
            />
            <path
              className="stage-images-aa"
              d="M5.379,0,4.109,4.108,0,4.11,3.325,6.65,2.056,10.76,5.379,8.22,8.7,10.76,7.435,6.65,10.76,4.11l-4.109,0Z"
              transform="translate(65.083 0)"
            />
            <rect
              className="stage-images-ab"
              width={35.911}
              height={2.993}
              rx={1.496}
              transform="translate(33.442 17.955)"
            />
            <rect
              className="stage-images-ab"
              width={35.911}
              height={2.993}
              rx={1.496}
              transform="translate(33.442 23.192)"
            />
            <rect
              className="stage-images-ab"
              width={35.911}
              height={2.993}
              rx={1.496}
              transform="translate(33.442 28.429)"
            />
            <rect
              className="stage-images-ab"
              width={27.681}
              height={2.993}
              rx={1.496}
              transform="translate(33.442 33.666)"
            />
            <text className="stage-images-ac" transform="translate(12 27.388)">
              <tspan x={-12.12} y={0}>
                {"4,6\t"}
              </tspan>
            </text>
          </g>
        </g>
        <g transform="translate(-15 23)">
          <rect
            className="stage-images-p"
            width={97.258}
            height={57.981}
            rx={10.8}
            transform="translate(1363.594 263.578)"
          />
          <g transform="translate(1375.3 272.656)">
            <g transform="translate(0 0)">
              <rect
                className="stage-images-ad"
                width={1.559}
                height={9.352}
                transform="translate(70.152 14.028)"
              />
              <rect
                className="stage-images-ad"
                width={1.559}
                height={9.352}
                transform="translate(71.711 14.028)"
              />
              <rect
                className="stage-images-ad"
                width={1.559}
                height={9.352}
                transform="translate(73.27 14.028)"
              />
              <rect
                className="stage-images-ad"
                width={1.559}
                height={9.352}
                transform="translate(88.077 14.028)"
              />
              <g transform="translate(29.552 0)">
                <path
                  className="stage-images-ae"
                  d="M6.1,0,4.657,4.382,0,4.384,3.768,7.093,2.33,11.477,6.1,8.768l3.769,2.709L8.427,7.093l3.768-2.709-4.657,0Z"
                />
              </g>
              <g transform="translate(43.58 0)">
                <path
                  className="stage-images-ae"
                  d="M6.1,0,4.657,4.382,0,4.384,3.768,7.093,2.33,11.477,6.1,8.768l3.769,2.709L8.427,7.093l3.768-2.709-4.657,0Z"
                />
              </g>
              <g transform="translate(57.607 0)">
                <path
                  className="stage-images-ae"
                  d="M6.1,0,4.657,4.382,0,4.384,3.768,7.093,2.33,11.477,6.1,8.768l3.769,2.709L8.427,7.093l3.768-2.709-4.657,0Z"
                />
              </g>
              <g transform="translate(15.564)">
                <path
                  className="stage-images-ae"
                  d="M6.1,0,4.657,4.382,0,4.384,3.768,7.093,2.33,11.477,6.1,8.768l3.769,2.709L8.427,7.093l3.768-2.709-4.657,0Z"
                />
              </g>
              <g transform="translate(1.577)">
                <path
                  className="stage-images-ae"
                  d="M6.1,0,4.657,4.382,0,4.384,3.768,7.093,2.33,11.477,6.1,8.768l3.769,2.709L8.427,7.093l3.768-2.709-4.657,0Z"
                />
              </g>
              <g transform="translate(1.577)">
                <path
                  className="stage-images-ae"
                  d="M6.1,0,4.657,4.382,0,4.384,3.768,7.093,2.33,11.477,6.1,8.768l3.769,2.709L8.427,7.093l3.768-2.709-4.657,0Z"
                />
              </g>
              <rect
                className="stage-images-ab"
                width={35.911}
                height={2.993}
                rx={1.496}
                transform="translate(33.779 20.128)"
              />
              <rect
                className="stage-images-ab"
                width={35.911}
                height={2.993}
                rx={1.496}
                transform="translate(33.779 25.365)"
              />
              <rect
                className="stage-images-ab"
                width={35.911}
                height={2.993}
                rx={1.496}
                transform="translate(33.779 30.602)"
              />
              <rect
                className="stage-images-ab"
                width={27.681}
                height={2.993}
                rx={1.496}
                transform="translate(33.779 35.839)"
              />
              <text
                className="stage-images-ac"
                transform="translate(10 30.704)"
              >
                <tspan x={-10.464} y={0}>
                  {"4,8"}
                </tspan>
              </text>
            </g>
          </g>
        </g>
        <g transform="translate(-15 31)">
          <rect
            className="stage-images-p"
            width={97.258}
            height={57.981}
            rx={10.8}
            transform="translate(1363.594 328.578)"
          />
          <g transform="translate(1363.594 256.578)">
            <rect
              className="stage-images-af"
              width={12.912}
              height={12.912}
              transform="translate(12.718 82.483)"
            />
            <path
              className="stage-images-p"
              d="M4.841,0,3.7,3.7,0,3.7,2.992,5.985l-1.142,3.7L4.841,7.4,7.834,9.684l-1.142-3.7L9.684,3.7l-3.7,0Z"
              transform="translate(14.332 84.097)"
            />
            <rect
              className="stage-images-af"
              width={12.912}
              height={12.912}
              transform="translate(27.244 82.483)"
            />
            <path
              className="stage-images-p"
              d="M4.841,0,3.7,3.7,0,3.7,2.992,5.985l-1.142,3.7L4.841,7.4,7.834,9.684l-1.142-3.7L9.684,3.7l-3.7,0Z"
              transform="translate(28.858 84.097)"
            />
            <rect
              className="stage-images-af"
              width={12.912}
              height={12.912}
              transform="translate(41.77 82.483)"
            />
            <path
              className="stage-images-p"
              d="M4.841,0,3.7,3.7,0,3.7,2.992,5.985l-1.142,3.7L4.841,7.4,7.834,9.684l-1.142-3.7L9.684,3.7l-3.7,0Z"
              transform="translate(43.384 84.097)"
            />
            <rect
              className="stage-images-af"
              width={12.912}
              height={12.912}
              transform="translate(56.296 82.483)"
            />
            <path
              className="stage-images-p"
              d="M4.841,0,3.7,3.7,0,3.7,2.992,5.985l-1.142,3.7L4.841,7.4,7.834,9.684l-1.142-3.7L9.684,3.7l-3.7,0Z"
              transform="translate(57.909 84.097)"
            />
            <rect
              className="stage-images-af"
              width={12.912}
              height={12.912}
              transform="translate(70.821 82.483)"
            />
            <path
              className="stage-images-p"
              d="M4.841,0,3.7,3.7,0,3.7,2.992,5.985l-1.142,3.7L4.841,7.4,7.834,9.684l-1.142-3.7L9.684,3.7l-3.7,0Z"
              transform="translate(72.435 84.097)"
            />
            <rect
              className="stage-images-ab"
              width={35.911}
              height={2.993}
              rx={1.496}
              transform="translate(45.637 103.442)"
            />
            <rect
              className="stage-images-ab"
              width={35.911}
              height={2.993}
              rx={1.496}
              transform="translate(45.637 108.679)"
            />
            <rect
              className="stage-images-ab"
              width={35.911}
              height={2.993}
              rx={1.496}
              transform="translate(45.637 113.916)"
            />
            <rect
              className="stage-images-ab"
              width={27.681}
              height={2.993}
              rx={1.496}
              transform="translate(45.637 119.153)"
            />
            <text
              className="stage-images-ac"
              transform="translate(20.57 113.98)"
            >
              <tspan x={-10.464} y={0}>
                {"4,5"}
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </svg>
  ) : (
    <svg
      width={453.316}
      height={275.034}
      viewBox="0 0 453.316 275.034"
      style={{ maxWidth: "100%", transform: "translateZ(0)" }}
    >
      <defs>
        <style>
          {
            ".StageImagesInd-a,.StageImagesInd-ab,.StageImagesInd-o{fill:#fff;}.StageImagesInd-b{fill:#0059c0;}.StageImagesInd-ac,.StageImagesInd-c{fill:#e5e5e5;}.StageImagesInd-d{font-size:16px;font-family:MyriadPro-Semibold, Myriad Pro;font-weight:600;}.StageImagesInd-aa,.StageImagesInd-ad,.StageImagesInd-af,.StageImagesInd-e,.StageImagesInd-i,.StageImagesInd-m,.StageImagesInd-y{fill:none;}.StageImagesInd-f{fill:#ffdc0f;}.StageImagesInd-g{fill:#12cc8a;}.StageImagesInd-h{fill:#e6f8fb;}.StageImagesInd-aa,.StageImagesInd-ad,.StageImagesInd-af,.StageImagesInd-h,.StageImagesInd-m{fill-rule:evenodd;}.StageImagesInd-i{stroke:#4f4a45;stroke-width:1.702px;}.StageImagesInd-aa,.StageImagesInd-ab,.StageImagesInd-ac,.StageImagesInd-ad,.StageImagesInd-i,.StageImagesInd-m,.StageImagesInd-r,.StageImagesInd-s,.StageImagesInd-u,.StageImagesInd-v,.StageImagesInd-y,.StageImagesInd-z{stroke-linecap:round;}.StageImagesInd-aa,.StageImagesInd-ab,.StageImagesInd-ac,.StageImagesInd-ad,.StageImagesInd-ae,.StageImagesInd-af,.StageImagesInd-i,.StageImagesInd-m,.StageImagesInd-o,.StageImagesInd-r,.StageImagesInd-s,.StageImagesInd-u,.StageImagesInd-v,.StageImagesInd-y,.StageImagesInd-z{stroke-linejoin:round;}.StageImagesInd-j,.StageImagesInd-u{fill:#45413c;}.StageImagesInd-j{opacity:0.15;}.StageImagesInd-k{fill:#ffc44d;}.StageImagesInd-l{fill:#ffdb94;}.StageImagesInd-ab,.StageImagesInd-ac,.StageImagesInd-ae,.StageImagesInd-af,.StageImagesInd-m,.StageImagesInd-o,.StageImagesInd-r,.StageImagesInd-s,.StageImagesInd-u,.StageImagesInd-v,.StageImagesInd-y,.StageImagesInd-z{stroke:#45413c;}.StageImagesInd-ae,.StageImagesInd-af,.StageImagesInd-m,.StageImagesInd-o,.StageImagesInd-r,.StageImagesInd-s,.StageImagesInd-u,.StageImagesInd-v,.StageImagesInd-y,.StageImagesInd-z{stroke-width:1.75px;}.StageImagesInd-n{fill:#f0f0f0;}.StageImagesInd-p,.StageImagesInd-r{fill:#ffcebf;}.StageImagesInd-q{fill:#ffb59e;}.StageImagesInd-s{fill:#ff8a14;}.StageImagesInd-t,.StageImagesInd-v{fill:#e8f4fa;}.StageImagesInd-w{fill:#0dbedc;}.StageImagesInd-x{fill:#1ad2f1;}.StageImagesInd-ae,.StageImagesInd-z{fill:#bdbec0;}.StageImagesInd-aa,.StageImagesInd-ad{stroke:gray;stroke-width:1.5px;}.StageImagesInd-aa{stroke-dasharray:4;}"
          }
        </style>
      </defs>
      <g transform="translate(-1007.619 -205.281)">
        <g transform="translate(11 -49)">
          <g transform="translate(-15 41)">
            <path
              className="StageImagesInd-a"
              d="M10.8,0H86.458a10.8,10.8,0,0,1,10.8,10.8V47.181a10.8,10.8,0,0,1-10.8,10.8H10.8A10.8,10.8,0,0,1,0,47.181V10.8A10.8,10.8,0,0,1,10.8,0Z"
              transform="translate(1363.594 393.473)"
            />
            <g transform="translate(1374.853 403.264)">
              <path
                className="StageImagesInd-b"
                d="M5.379,0,4.109,4.108,0,4.11,3.325,6.65,2.056,10.76,5.379,8.22,8.7,10.76,7.435,6.65,10.76,4.11l-4.109,0Z"
                transform="translate(0.524 0)"
              />
              <path
                className="StageImagesInd-b"
                d="M5.379,0,4.109,4.108,0,4.11,3.325,6.65,2.056,10.76,5.379,8.22,8.7,10.76,7.435,6.65,10.76,4.11l-4.109,0Z"
                transform="translate(0.524)"
              />
              <path
                className="StageImagesInd-b"
                d="M5.379,0,4.109,4.108,0,4.11,3.325,6.65,2.056,10.76,5.379,8.22,8.7,10.76,7.435,6.65,10.76,4.11l-4.109,0Z"
                transform="translate(16.664 0)"
              />
              <path
                className="StageImagesInd-b"
                d="M5.379,0,4.109,4.108,0,4.11,3.325,6.65,2.056,10.76,5.379,8.22,8.7,10.76,7.435,6.65,10.76,4.11l-4.109,0Z"
                transform="translate(32.803 0)"
              />
              <path
                className="StageImagesInd-b"
                d="M5.379,0,4.109,4.108,0,4.11,3.325,6.65,2.056,10.76,5.379,8.22,8.7,10.76,7.435,6.65,10.76,4.11l-4.109,0Z"
                transform="translate(48.943 0)"
              />
              <path
                className="StageImagesInd-b"
                d="M5.379,0,4.109,4.108,0,4.11,3.325,6.65,2.056,10.76,5.379,8.22,8.7,10.76,7.435,6.65,10.76,4.11l-4.109,0Z"
                transform="translate(65.083 0)"
              />
              <rect
                className="StageImagesInd-c"
                width={35.911}
                height={2.993}
                rx={1.496}
                transform="translate(33.442 17.955)"
              />
              <rect
                className="StageImagesInd-c"
                width={35.911}
                height={2.993}
                rx={1.496}
                transform="translate(33.442 23.192)"
              />
              <rect
                className="StageImagesInd-c"
                width={35.911}
                height={2.993}
                rx={1.496}
                transform="translate(33.442 28.429)"
              />
              <rect
                className="StageImagesInd-c"
                width={27.681}
                height={2.993}
                rx={1.496}
                transform="translate(33.442 33.666)"
              />
              <text
                className="StageImagesInd-d"
                transform="translate(12 27.388)"
              >
                <tspan x={-12.12} y={0}>
                  {"4,6\t"}
                </tspan>
              </text>
            </g>
          </g>
          <g transform="translate(-15 23)">
            <rect
              className="StageImagesInd-a"
              width={97.258}
              height={57.981}
              rx={10.8}
              transform="translate(1363.594 263.578)"
            />
            <g transform="translate(1375.3 272.656)">
              <g transform="translate(0 0)">
                <rect
                  className="StageImagesInd-e"
                  width={1.559}
                  height={9.352}
                  transform="translate(70.152 14.028)"
                />
                <rect
                  className="StageImagesInd-e"
                  width={1.559}
                  height={9.352}
                  transform="translate(71.711 14.028)"
                />
                <rect
                  className="StageImagesInd-e"
                  width={1.559}
                  height={9.352}
                  transform="translate(73.27 14.028)"
                />
                <rect
                  className="StageImagesInd-e"
                  width={1.559}
                  height={9.352}
                  transform="translate(88.077 14.028)"
                />
                <g transform="translate(29.552 0)">
                  <path
                    className="StageImagesInd-f"
                    d="M6.1,0,4.657,4.382,0,4.384,3.768,7.093,2.33,11.477,6.1,8.768l3.769,2.709L8.427,7.093l3.768-2.709-4.657,0Z"
                  />
                </g>
                <g transform="translate(43.58 0)">
                  <path
                    className="StageImagesInd-f"
                    d="M6.1,0,4.657,4.382,0,4.384,3.768,7.093,2.33,11.477,6.1,8.768l3.769,2.709L8.427,7.093l3.768-2.709-4.657,0Z"
                  />
                </g>
                <g transform="translate(57.607 0)">
                  <path
                    className="StageImagesInd-f"
                    d="M6.1,0,4.657,4.382,0,4.384,3.768,7.093,2.33,11.477,6.1,8.768l3.769,2.709L8.427,7.093l3.768-2.709-4.657,0Z"
                  />
                </g>
                <g transform="translate(15.564)">
                  <path
                    className="StageImagesInd-f"
                    d="M6.1,0,4.657,4.382,0,4.384,3.768,7.093,2.33,11.477,6.1,8.768l3.769,2.709L8.427,7.093l3.768-2.709-4.657,0Z"
                  />
                </g>
                <g transform="translate(1.577)">
                  <path
                    className="StageImagesInd-f"
                    d="M6.1,0,4.657,4.382,0,4.384,3.768,7.093,2.33,11.477,6.1,8.768l3.769,2.709L8.427,7.093l3.768-2.709-4.657,0Z"
                  />
                </g>
                <g transform="translate(1.577)">
                  <path
                    className="StageImagesInd-f"
                    d="M6.1,0,4.657,4.382,0,4.384,3.768,7.093,2.33,11.477,6.1,8.768l3.769,2.709L8.427,7.093l3.768-2.709-4.657,0Z"
                  />
                </g>
                <rect
                  className="StageImagesInd-c"
                  width={35.911}
                  height={2.993}
                  rx={1.496}
                  transform="translate(33.779 20.128)"
                />
                <rect
                  className="StageImagesInd-c"
                  width={35.911}
                  height={2.993}
                  rx={1.496}
                  transform="translate(33.779 25.365)"
                />
                <rect
                  className="StageImagesInd-c"
                  width={35.911}
                  height={2.993}
                  rx={1.496}
                  transform="translate(33.779 30.602)"
                />
                <rect
                  className="StageImagesInd-c"
                  width={27.681}
                  height={2.993}
                  rx={1.496}
                  transform="translate(33.779 35.839)"
                />
                <text
                  className="StageImagesInd-d"
                  transform="translate(10 30.704)"
                >
                  <tspan x={-10.464} y={0}>
                    {"4,8"}
                  </tspan>
                </text>
              </g>
            </g>
          </g>
          <g transform="translate(-15 31)">
            <rect
              className="StageImagesInd-a"
              width={97.258}
              height={57.981}
              rx={10.8}
              transform="translate(1363.594 328.578)"
            />
            <g transform="translate(1363.594 256.578)">
              <rect
                className="StageImagesInd-g"
                width={12.912}
                height={12.912}
                transform="translate(12.718 82.483)"
              />
              <path
                className="StageImagesInd-a"
                d="M4.841,0,3.7,3.7,0,3.7,2.992,5.985l-1.142,3.7L4.841,7.4,7.834,9.684l-1.142-3.7L9.684,3.7l-3.7,0Z"
                transform="translate(14.332 84.097)"
              />
              <rect
                className="StageImagesInd-g"
                width={12.912}
                height={12.912}
                transform="translate(27.244 82.483)"
              />
              <path
                className="StageImagesInd-a"
                d="M4.841,0,3.7,3.7,0,3.7,2.992,5.985l-1.142,3.7L4.841,7.4,7.834,9.684l-1.142-3.7L9.684,3.7l-3.7,0Z"
                transform="translate(28.858 84.097)"
              />
              <rect
                className="StageImagesInd-g"
                width={12.912}
                height={12.912}
                transform="translate(41.77 82.483)"
              />
              <path
                className="StageImagesInd-a"
                d="M4.841,0,3.7,3.7,0,3.7,2.992,5.985l-1.142,3.7L4.841,7.4,7.834,9.684l-1.142-3.7L9.684,3.7l-3.7,0Z"
                transform="translate(43.384 84.097)"
              />
              <rect
                className="StageImagesInd-g"
                width={12.912}
                height={12.912}
                transform="translate(56.296 82.483)"
              />
              <path
                className="StageImagesInd-a"
                d="M4.841,0,3.7,3.7,0,3.7,2.992,5.985l-1.142,3.7L4.841,7.4,7.834,9.684l-1.142-3.7L9.684,3.7l-3.7,0Z"
                transform="translate(57.909 84.097)"
              />
              <rect
                className="StageImagesInd-g"
                width={12.912}
                height={12.912}
                transform="translate(70.821 82.483)"
              />
              <path
                className="StageImagesInd-a"
                d="M4.841,0,3.7,3.7,0,3.7,2.992,5.985l-1.142,3.7L4.841,7.4,7.834,9.684l-1.142-3.7L9.684,3.7l-3.7,0Z"
                transform="translate(72.435 84.097)"
              />
              <rect
                className="StageImagesInd-c"
                width={35.911}
                height={2.993}
                rx={1.496}
                transform="translate(45.637 103.442)"
              />
              <rect
                className="StageImagesInd-c"
                width={35.911}
                height={2.993}
                rx={1.496}
                transform="translate(45.637 108.679)"
              />
              <rect
                className="StageImagesInd-c"
                width={35.911}
                height={2.993}
                rx={1.496}
                transform="translate(45.637 113.916)"
              />
              <rect
                className="StageImagesInd-c"
                width={27.681}
                height={2.993}
                rx={1.496}
                transform="translate(45.637 119.153)"
              />
              <text
                className="StageImagesInd-d"
                transform="translate(20.57 113.98)"
              >
                <tspan x={-10.464} y={0}>
                  {"4,5"}
                </tspan>
              </text>
            </g>
          </g>
        </g>
        <g transform="translate(-10 -37)">
          <g transform="translate(1013.735 298.16)">
            <g transform="translate(4.735 10.893)">
              <g transform="translate(0)">
                <path
                  className="StageImagesInd-h"
                  d="M112.934,0a106.121,106.121,0,0,1,96.452,150.267H16.482A106.121,106.121,0,0,1,112.934,0Z"
                  transform="translate(3.248)"
                />
                <line
                  className="StageImagesInd-i"
                  x2={208.927}
                  transform="translate(12.053 150.831)"
                />
                <line
                  className="StageImagesInd-i"
                  x2={6.696}
                  transform="translate(0 150.831)"
                />
                <line
                  className="StageImagesInd-i"
                  x2={6.696}
                  transform="translate(224.864 150.831)"
                />
              </g>
            </g>
            <g transform="translate(-6.468 1.887)">
              <g transform="translate(0 0)">
                <path
                  className="StageImagesInd-j"
                  d="M69.968,127.913c0,2.135-7.966,3.867-19.14,3.867s-16.954-1.732-16.954-3.867,5.778-3.867,16.954-3.867S69.968,125.783,69.968,127.913Z"
                  transform="translate(12.299 55.919)"
                />
                <g transform="translate(52.299 16.101)">
                  <g transform="translate(28.061 0)">
                    <path
                      className="StageImagesInd-k"
                      d="M91.989,72.648a12.071,12.071,0,0,0-7.964-11.31,8.451,8.451,0,0,0,.83-3.622,8.546,8.546,0,0,0-.443-2.578,12,12,0,0,0-3.9-21.03,34.364,34.364,0,0,0-68.693,0A12,12,0,0,0,7.909,55.135a8.08,8.08,0,0,0,.384,6.2A12.042,12.042,0,0,0,9.5,84.363,8.528,8.528,0,0,0,17.381,96.15c.173,0,.335-.039.516-.049a8.508,8.508,0,0,0,8.023,5.752h.142a8.508,8.508,0,0,0,7.273,7.025,13.218,13.218,0,0,0,25.657,0,8.508,8.508,0,0,0,7.273-7.025h.142A8.508,8.508,0,0,0,74.424,96.1c.173,0,.335.049.516.049a8.528,8.528,0,0,0,7.881-11.787A12.076,12.076,0,0,0,91.989,72.648Z"
                      transform="translate(-0.33 -0.815)"
                    />
                    <path
                      className="StageImagesInd-l"
                      d="M10.891,44.068a34.364,34.364,0,0,1,68.693,0,12.169,12.169,0,0,1,7.51,6.533,11.831,11.831,0,0,0,1.088-4.986,12.053,12.053,0,0,0-8.6-11.509,34.364,34.364,0,0,0-68.693,0,12.058,12.058,0,0,0-8.6,11.509A11.8,11.8,0,0,0,3.381,50.6a12.163,12.163,0,0,1,7.51-6.533Z"
                      transform="translate(0.597 -0.816)"
                    />
                    <path
                      className="StageImagesInd-m"
                      d="M91.989,72.648a12.071,12.071,0,0,0-7.964-11.31,8.451,8.451,0,0,0,.83-3.622,8.546,8.546,0,0,0-.443-2.578,12,12,0,0,0-3.9-21.03,34.364,34.364,0,0,0-68.693,0A12,12,0,0,0,7.909,55.135a8.08,8.08,0,0,0,.384,6.2A12.042,12.042,0,0,0,9.5,84.363,8.528,8.528,0,0,0,17.381,96.15c.173,0,.335-.039.516-.049a8.508,8.508,0,0,0,8.023,5.752h.142a8.508,8.508,0,0,0,7.273,7.025,13.218,13.218,0,0,0,25.657,0,8.508,8.508,0,0,0,7.273-7.025h.142A8.508,8.508,0,0,0,74.424,96.1c.173,0,.335.049.516.049a8.528,8.528,0,0,0,7.881-11.787A12.076,12.076,0,0,0,91.989,72.648Z"
                      transform="translate(-0.33 -0.815)"
                    />
                  </g>
                  <g transform="translate(2.836 74.079)">
                    <path
                      className="StageImagesInd-n"
                      d="M70.852,7.1A44.057,44.057,0,0,0,26.795,51.159V65.815a3.674,3.674,0,0,1-5.527,3.011L15.6,65.418A8.552,8.552,0,0,0,6.789,80.08c5.785,3.475,9.5,6.35,16.291,6.35A20.723,20.723,0,0,0,42.436,72.485h72.473V51.159A44.057,44.057,0,0,0,70.852,7.1Z"
                      transform="translate(0.206 2.845)"
                    />
                    <path
                      className="StageImagesInd-a"
                      d="M63.093,7.1A44.057,44.057,0,0,0,19.036,51.159V62.528a44.057,44.057,0,0,1,88.114,0V51.159A44.057,44.057,0,0,0,63.093,7.1Z"
                      transform="translate(7.965 2.845)"
                    />
                    <path
                      className="StageImagesInd-m"
                      d="M70.852,7.1A44.057,44.057,0,0,0,26.795,51.159V65.815a3.674,3.674,0,0,1-5.527,3.011L15.6,65.418A8.552,8.552,0,0,0,6.789,80.08c5.785,3.475,9.5,6.35,16.291,6.35A20.723,20.723,0,0,0,42.436,72.485h72.473V51.159A44.057,44.057,0,0,0,70.852,7.1Z"
                      transform="translate(0.206 2.845)"
                    />
                    <path
                      className="StageImagesInd-o"
                      d="M57.572,3.243H50.467a12.081,12.081,0,1,0,0,24.159h7.105a12.081,12.081,0,1,0,0-24.159Z"
                      transform="translate(17.038 1.018)"
                    />
                    <path
                      className="StageImagesInd-p"
                      d="M42.188.35v15.9s-.111,6.757,9.949,6.84c10.055-.082,9.949-6.84,9.949-6.84V.35Z"
                      transform="translate(18.921 -0.35)"
                    />
                    <path
                      className="StageImagesInd-q"
                      d="M42.188,9.162c0,.394.2,6.737,9.949,6.819,9.745-.082,9.946-6.425,9.949-6.819V.35h-19.9Z"
                      transform="translate(18.921 -0.35)"
                    />
                    <path
                      className="StageImagesInd-m"
                      d="M42.188.35v15.9s-.111,6.757,9.949,6.84c10.055-.082,9.949-6.84,9.949-6.84V.35Z"
                      transform="translate(18.921 -0.35)"
                    />
                    <path
                      className="StageImagesInd-r"
                      d="M12.488,45.689H8.827a8.209,8.209,0,0,0-8.118,8.3v7.907A3.424,3.424,0,0,0,3.2,65.149a27.024,27.024,0,0,0,14.914,0,3.416,3.416,0,0,0,2.49-3.254V53.988a8.206,8.206,0,0,0-8.116-8.3Z"
                      transform="translate(-0.708 21.104)"
                    />
                    <path
                      className="StageImagesInd-m"
                      d="M30.865,63.573V54.05c0-8.33-6.484-11.171-2.49-21.158.846-2.062,1.787-4.641,2.49-6.979"
                      transform="translate(11.769 11.746)"
                    />
                    <path
                      className="StageImagesInd-m"
                      d="M68.235,63.573V54.05c0-8.33,6.486-11.171,2.49-21.158-.846-2.062-1.787-4.641-2.49-6.979"
                      transform="translate(31.246 11.746)"
                    />
                  </g>
                  <g transform="translate(39.739 22.839)">
                    <g transform="translate(0 0)">
                      <path
                        className="StageImagesInd-r"
                        d="M68.817,27.608a5.692,5.692,0,0,0-5.692-5.692c-17.077,0-25.546-6.355-31.308-21.347C28.9,6.081,24.7,21.915,6.2,21.915A5.692,5.692,0,0,0,6.2,33.3c.119,0,.232-.026.348-.034a28.426,28.426,0,0,0,56.228,0c.119,0,.229.034.348.034a5.69,5.69,0,0,0,5.692-5.692Z"
                        transform="translate(-0.507 -0.569)"
                      />
                      <circle
                        className="StageImagesInd-q"
                        cx={3.558}
                        cy={3.558}
                        r={3.558}
                        transform="translate(14.231 29.885)"
                      />
                      <circle
                        className="StageImagesInd-q"
                        cx={3.558}
                        cy={3.558}
                        r={3.558}
                        transform="translate(46.963 29.885)"
                      />
                      <path
                        className="StageImagesInd-m"
                        d="M34.973,28.175a12.305,12.305,0,0,1-17.077,0"
                        transform="translate(7.721 12.495)"
                      />
                      <path
                        className="StageImagesInd-m"
                        d="M21.6,17.9a4.625,4.625,0,0,0-8.539,0"
                        transform="translate(5.435 6.288)"
                      />
                      <path
                        className="StageImagesInd-m"
                        d="M37.06,17.9a4.625,4.625,0,0,0-8.539,0"
                        transform="translate(12.749 6.288)"
                      />
                    </g>
                    <path
                      className="StageImagesInd-s"
                      d="M5.3,22.787S3.856,37.018,2.431,38.438a2.846,2.846,0,0,0,5.692,0C6.7,37.02,5.3,22.787,5.3,22.787Z"
                      transform="translate(0.403 9.945)"
                    />
                    <path
                      className="StageImagesInd-s"
                      d="M43.932,22.787s-1.439,14.231-2.864,15.652a2.846,2.846,0,0,0,5.692,0C45.339,37.02,43.932,22.787,43.932,22.787Z"
                      transform="translate(18.685 9.945)"
                    />
                  </g>
                  <g transform="translate(0 147.977)">
                    <path
                      className="StageImagesInd-a"
                      d="M23.744,18.987H3.377a2.836,2.836,0,0,1-2.81-3.274l.719-4.666A12.424,12.424,0,0,1,13.565.512h0A12.426,12.426,0,0,1,25.845,11.046l.717,4.666a2.836,2.836,0,0,1-2.818,3.274Z"
                      transform="translate(-0.533 -0.512)"
                    />
                    <path
                      className="StageImagesInd-t"
                      d="M13.372,4.371A12.421,12.421,0,0,0,1.093,14.9l-.168,1.08a2.792,2.792,0,0,0,2.258,1.176H23.55a2.792,2.792,0,0,0,2.258-1.176l-.165-1.08A12.424,12.424,0,0,0,13.372,4.371Z"
                      transform="translate(-0.347 1.314)"
                    />
                    <path
                      className="StageImagesInd-m"
                      d="M23.744,18.987H3.377a2.836,2.836,0,0,1-2.81-3.274l.719-4.666A12.424,12.424,0,0,1,13.565.512h0A12.426,12.426,0,0,1,25.845,11.046l.717,4.666a2.836,2.836,0,0,1-2.818,3.274Z"
                      transform="translate(-0.533 -0.512)"
                    />
                    <circle
                      className="StageImagesInd-u"
                      cx={1.473}
                      cy={1.473}
                      r={1.473}
                      transform="translate(11.31 5.426)"
                    />
                  </g>
                </g>
                <g transform="translate(70.122 192.517)">
                  <path
                    className="StageImagesInd-v"
                    d="M24.26,18.69H3.377A2.983,2.983,0,0,1,.384,15.71V12.722H27.243V15.71A2.983,2.983,0,0,1,24.26,18.69Z"
                    transform="translate(-0.379 5.186)"
                  />
                  <path
                    className="StageImagesInd-w"
                    d="M27.243,18.474H.384L5.672,2.608A2.985,2.985,0,0,1,8.508.566H19.13a2.985,2.985,0,0,1,2.836,2.042Z"
                    transform="translate(-0.379 -0.566)"
                  />
                  <path
                    className="StageImagesInd-x"
                    d="M19.126.575H8.5A2.985,2.985,0,0,0,5.668,2.617L.381,18.482h1.83L21.887,2.447A2.985,2.985,0,0,0,19.126.575Z"
                    transform="translate(-0.381 -0.562)"
                  />
                  <path
                    className="StageImagesInd-m"
                    d="M27.243,18.474H.384L5.672,2.608A2.985,2.985,0,0,1,8.508.566H19.13a2.985,2.985,0,0,1,2.836,2.042Z"
                    transform="translate(-0.379 -0.566)"
                  />
                  <line
                    className="StageImagesInd-y"
                    x2={2.985}
                    transform="translate(11.942 4.112)"
                  />
                  <rect
                    className="StageImagesInd-z"
                    width={5.968}
                    height={5.968}
                    transform="translate(14.927 17.907)"
                  />
                </g>
              </g>
            </g>
          </g>
          <g transform="translate(1014.478 299.033)">
            <path
              className="StageImagesInd-aa"
              d="M6.022-70.861C-33.3-41.258,35.131,13.613,16,23.154,11.9,30.508-9.626,51.771-10.326,67.93c-.707,16.337,15.528,39.939,27.94,56.041"
              transform="translate(253.932 69.388) rotate(47)"
            />
            <g transform="translate(294.124 40.776)">
              <g transform="translate(17.614 -33.5) rotate(43)">
                <path
                  className="StageImagesInd-ab"
                  d="M.335,2.166A1.288,1.288,0,0,1,.136.723,1.315,1.315,0,0,1,1.417,0L44.6,3.4a1.309,1.309,0,0,1,1.161.952,1.292,1.292,0,0,1-.509,1.4L9.841,30.439a1.324,1.324,0,0,1-1.472.027A1.292,1.292,0,0,1,7.8,29.123l2.953-14.688a1.287,1.287,0,0,0-.309-1.12Z"
                />
                <path
                  className="StageImagesInd-ac"
                  d="M2.978,10.089.025,24.777A1.293,1.293,0,0,0,.6,26.119a1.325,1.325,0,0,0,1.471-.026L37.479,1.406A1.293,1.293,0,0,0,37.989,0L2.956,9.493A1.276,1.276,0,0,1,2.978,10.089Z"
                  transform="translate(7.773 4.347)"
                />
              </g>
            </g>
            <path
              className="StageImagesInd-aa"
              d="M-25.023-88.748C-59.3-39.773-4.241,7.07,7.608,17.527,27.687,36.853,15.468,92.867,35,104.54q14.466,8.645,37.356,44.371"
              transform="translate(242.157 26.516) rotate(60)"
            />
            <g transform="matrix(0.891, 0.454, -0.454, 0.891, 304.714, -56.064)">
              <g transform="translate(0 0)">
                <path
                  className="StageImagesInd-ab"
                  d="M.335,2.166A1.288,1.288,0,0,1,.136.723,1.315,1.315,0,0,1,1.417,0L44.6,3.4a1.309,1.309,0,0,1,1.161.952,1.292,1.292,0,0,1-.509,1.4L9.841,30.439a1.324,1.324,0,0,1-1.472.027A1.292,1.292,0,0,1,7.8,29.123l2.953-14.688a1.287,1.287,0,0,0-.309-1.12Z"
                />
                <path
                  className="StageImagesInd-ac"
                  d="M2.978,10.089.025,24.777A1.293,1.293,0,0,0,.6,26.119a1.325,1.325,0,0,0,1.471-.026L37.479,1.406A1.293,1.293,0,0,0,37.989,0L2.956,9.493A1.276,1.276,0,0,1,2.978,10.089Z"
                  transform="translate(7.773 4.347)"
                />
              </g>
            </g>
            <g transform="translate(319.315 72.105) rotate(60)">
              <g transform="translate(0 0)">
                <g transform="translate(41.192 179.15) rotate(178)">
                  <path
                    className="StageImagesInd-aa"
                    d="M-8.165,118.922C-8.8,58.033,7.874,41.558,25.47,54.454c2.057,1.608,3.561,5,4.025,9.069a23.47,23.47,0,0,1-1.361,11.444c-2.947,6.75-7.954,8.967-12.21,5.4C-1.516,66.42,10.565,9.514,31.653,0"
                    transform="translate(0 1.897)"
                  />
                  <path
                    className="StageImagesInd-ad"
                    d="M0,.2A13.529,13.529,0,0,1,1.456,0"
                    transform="translate(35.28 0)"
                  />
                </g>
                <g transform="matrix(0.743, -0.669, 0.669, 0.743, 21.55, 56.387)">
                  <path
                    className="StageImagesInd-ab"
                    d="M.351,2.708A1.458,1.458,0,0,1,.141.892,2.075,2.075,0,0,1,1.99-.077L62.973,2.172a1.657,1.657,0,0,1,1.6,1.149,1.655,1.655,0,0,1-.791,1.8L12.4,38.014a2.075,2.075,0,0,1-2.086.1,1.458,1.458,0,0,1-.742-1.671l4.914-18.715a1.43,1.43,0,0,0-.382-1.4Z"
                    transform="translate(2.257 -0.425)"
                  />
                  <path
                    className="StageImagesInd-ac"
                    d="M3.464,11.956l-5,18.383a1.415,1.415,0,0,0,.756,1.64,2.179,2.179,0,0,0,2.122-.1l52.3-32.31a1.605,1.605,0,0,0,.806-1.77L3.463,11.217A1.366,1.366,0,0,1,3.464,11.956Z"
                    transform="translate(12.602 6.086)"
                  />
                </g>
              </g>
            </g>
          </g>
          <g transform="translate(1107.43 439.195)">
            <path
              className="StageImagesInd-j"
              d="M109.356,44.36c0,2.728-23.976,4.937-57.582,4.937s-51-2.212-51-4.937,17.384-4.934,51-4.934S109.356,41.635,109.356,44.36Z"
              transform="translate(-0.772 18.156)"
            />
            <path
              className="StageImagesInd-ae"
              d="M95.519,43.185H10.364a5.156,5.156,0,0,1-5.156-5.156V34.958h95.467v3.071A5.156,5.156,0,0,1,95.519,43.185Z"
              transform="translate(1.327 16.042)"
            />
            <path
              className="StageImagesInd-n"
              d="M102.244,51.339H6.777L1.94,7.713A6.584,6.584,0,0,1,8.473.34H100.6a6.584,6.584,0,0,1,6.533,7.373Z"
              transform="translate(-0.241 -0.34)"
            />
            <path
              className="StageImagesInd-a"
              d="M2.646,14.112a6.033,6.033,0,0,1,.9-1.686A6.574,6.574,0,0,1,8.47,10.211H100.6a6.574,6.574,0,0,1,4.924,2.215,6.079,6.079,0,0,1,.892,1.673l.717-6.386A6.584,6.584,0,0,0,100.6.34H8.47A6.584,6.584,0,0,0,1.937,7.713Z"
              transform="translate(-0.243 -0.34)"
            />
            <path
              className="StageImagesInd-af"
              d="M102.244,51.339H6.777L1.94,7.713A6.584,6.584,0,0,1,8.473.34H100.6a6.584,6.584,0,0,1,6.533,7.373Z"
              transform="translate(-0.241 -0.34)"
            />
          </g>
        </g>
      </g>
    </svg>
  );

export default StageImages;
